import styled from "styled-components";

export const UserImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  object-fit: cover;
`;

export const ChatUser = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  border-radius: 0;
  margin: 0;
  padding: 0.5rem 1.3rem;
  border-radius: 5px;

  .last-message-time {
    color: #8b8b8b;
    font-size: 12px;
  }

  &:hover {
    background-color: #393939;
  }

  @media screen and (max-width: 800px) {
    justify-content: left;
    width: 90vw;
  }
`;

export const LastMessage = styled.div`
  font-size: 18px;
  color: #ffffff;
`;

export const UserDetail = styled.div`
  min-width: 0;
`;

export const UserName = styled.p`
  color: white;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
`;

export const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  overflow-y: auto;
  padding: 1rem 1rem 5rem 1rem;
  scroll-padding-top: 2rem;
  scroll-padding-bottom: 2.5rem;
`;

export const MessageBox = styled.div``;

export const MessageDate = styled.div.attrs((props) => ({
  className: "font-roboto",
}))`
  text-align: center;
  background-color: #353535;
  color: #9d9d9d;
  font-weight: 500;
  border: 5px;
  padding: 0.25rem 0.5rem;
  width: fit-content;
  margin: auto;
  position: sticky;
  top: 1rem;
  font-size: 14px;
  border-radius: 4px;
  z-index: 1;
`;

export const Messages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1rem;
  width: 100%;
`;

export const TextMessageWrapper = styled.div<{ isRemote: boolean }>`
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  justify-content: ${({ isRemote }) => (isRemote ? "flex-start" : "flex-end")};
  width: 100%;
  flex-direction: ${({ isRemote }) => (isRemote ? "row" : "unset")};
`;

export const Message = styled.div<{ isRemote: boolean }>`
  width: fit-content;
  max-width: 70%;
  padding: 1rem;
  padding-bottom: 0.4rem;
  font-size: 15px;
  border-radius: 10px;
  background-color: ${({ isRemote }) => (isRemote ? "#ffffff" : "#2F80ED")};
  color: ${({ isRemote }) => (isRemote ? "#1B1A57" : "#ffffff")};
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const Text = styled.div`
  word-break: break-word;
  white-space: pre-wrap;
`;

export const Time = styled.div<{ isRemote: boolean }>`
  color: ${({ isRemote }) => (isRemote ? "#A1A1BC" : "#ffffff")};
  font-size: 12px;
  text-align: right;
  margin-top: 0.5rem;
`;

export const Username = styled.div<{ remote: string }>`
  font-size: 12px;
  margin: 0 3rem 0 3rem;
  color: ${(props) => (props.remote === "true" ? "#e0e0e0" : "#e0e0e0")};
  text-align: ${(props) => (props.remote === "true" ? "left" : "right")};
  opacity: 0.8;
`;

export const ChatContent = styled.div`
  display: flex;
  min-height: 16px;

  p {
    color: rgba(255, 255, 255, 0.7);
  }

  .last-seen {
    font-size: 12px;
    flex: none;
  }

  .last-message {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 14px;
    padding-right: 8px;
  }
`;

export const CreatorPresenceText = styled.span<{ $online: boolean }>`
  color: ${({ $online }) => ($online ? "#34d399" : "rgba(255, 255, 255, 0.46)")};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
`;

export const ProfileImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

export const ImageWrapper = styled.div`
  position: relative;
  flex: none;
`;

export const OnlineDot = styled.span`
  position: absolute;
  left: -1px;
  bottom: 0;
  width: 11px;
  height: 11px;
  border: 2px solid #000000;
  border-radius: 9999px;
  background: #22c55e;
  box-shadow: 0 0 0 1px rgba(34, 197, 94, 0.22);
`;

export const UnreadBadge = styled.span`
  position: absolute;
  bottom: -2px;
  right: -2px;
  background-color: #dc2626;
  color: white;
  border-radius: 9999px;
  font-size: 10px;
  padding: 2px 6px;
  min-width: 16px;
  text-align: center;
  font-weight: bold;
  line-height: 1;
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 9px;
    padding: 2px 5px;
    right: -4px;
    bottom: -4px;
  }
`;
